import AboutKonaspiXII from "@/components/public/AboutKonaspiXII";

export default function AboutPage() {
        return (
            <div className="mx-auto">
                <AboutKonaspiXII />
            </div>
        );

}
